export default () => {
    return {
        plotOptions: {
            series: {
                stickyTracking: false,
            },
        },
    };
};
